import { useState } from 'react';

const faqs = [
  {
    q: 'h漫画网站是否免费？',
    a: '是的，h漫画平台提供大量免费漫画内容供读者阅读。部分VIP章节可能需要订阅，但我们会持续提供丰富的免费内容，保证大家的阅读体验。',
  },
  {
    q: '支持哪些设备阅读？',
    a: 'h漫画支持PC端、平板和手机端阅读，采用响应式设计，自动适配不同屏幕尺寸。无论您使用什么设备，都能获得流畅舒适的阅读体验。',
  },
  {
    q: '漫画更新频率如何？',
    a: '我们的编辑团队每日更新漫画内容，热门连载作品保证周更，部分爆款作品甚至日更。关注您喜欢的作品，不错过任何精彩章节。',
  },
  {
    q: '如何找到想看的漫画？',
    a: '您可以通过首页的分类导航进入不同风格的漫画专区，也可以在搜索功能中通过作品名或作者名查找。热门推荐和最新更新区域也能帮您发现优质内容。',
  },
  {
    q: '漫画内容是否正版授权？',
    a: 'h漫画始终坚持正版理念，所有上线作品均已获得版权方授权。我们尊重每一位创作者的劳动成果，为读者提供合法合规的阅读环境。',
  },
  {
    q: '如何联系客服？',
    a: '您可以通过关于我们页面的联系方式与我们取得联系，包括邮箱（contact@hmanga.com）、客服QQ等渠道，我们的客服团队将在工作时间内尽快回复。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            关于h漫画平台，您想了解的问题都在这里
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-medium text-foreground-900 text-sm pr-4">{faq.q}</span>
                <i
                  className={`ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-foreground-500 transition-transform duration-200 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}